module.exports = __webpack_public_path__ + "media/images/ln/constellation_07-ed28de59c3482f575baea2ccf49a3893.png";